<template>
  <form @submit.prevent="onSubmit" class="shadow-lg p-5">

    <div class="w-full mb-5">
      <label class="block font-semibold mb-2">Name</label>
      <input class="w-full outline-none text-sm border border-gray-primary text-gray-secondary py-2 px-4 pr-8 rounded" type="text" v-model.trim="user.name" required>
    </div>
    
    <div class="w-full mb-5">
      <label class="block font-semibold mb-2">Email</label>
      <input class="w-full outline-none text-sm border border-gray-primary text-gray-secondary py-2 px-4 pr-8 rounded" type="email" v-model.trim="user.email" :readonly="defaultUser" required>
    </div>

		<div class="w-full mb-5">
      <label class="block font-semibold mb-2">Department</label>
      <input class="w-full outline-none text-sm border border-gray-primary text-gray-secondary py-2 px-4 pr-8 rounded" type="text" v-model.trim="user.department">
    </div>

    <div class="w-full mb-5">
      <label class="block font-semibold mb-2">Scope of Work</label>
      <textarea row="2" class="w-full outline-none text-sm border border-gray-primary text-gray-secondary py-2 px-4 pr-8 rounded" type="text" v-model="user.scope_of_work"></textarea>
    </div>
    
    <div class="w-full mb-5">
      <label class="block font-semibold mb-2">Role</label>
      <v-select v-model="user.role" :options="roles" :reduce="role => role.name" label="name" aria-required="true"></v-select>
    </div>

    <span v-if="user.role == 'Person In Charge'">
      <div class="w-full mb-5">
        <label class="block font-semibold">Category of Tickets</label>
        <v-select v-model="user.categories" :options="categories" :reduce="category => category.id" label="title" multiple></v-select>
        <label class="font-light text-xs">Category of tickets user will be handling</label>
      </div>
      <div class="w-full mb-5">
        <label class="block font-semibold mb-2">Projects</label>
        <v-select v-model="user.projects" :options="projects" :reduce="project => project.id" label="name" multiple></v-select>
      </div>
    </span>

    <button class="mt-3 sm:mt-0 inline-block bg-gold-primary focus:outline-none hover:opacity-75 duration-200 ease-in-out text-sm text-white px-6 py-2 rounded-full" type="submit" v-if="!loading">{{ defaultUser ? 'Update' : 'Create' }}</button>
    <button class="mt-3 sm:mt-0 inline-block bg-gold-primary focus:outline-none hover:opacity-75 duration-200 ease-in-out text-sm text-white px-6 py-2 rounded-full" type="submit" disabled v-else>Loading...</button>
  </form>
</template>


<script>

  import UserServices from '@vue/Services/UserServices';

  export default {
    props: {
      categories: { required: true, type: Array },
      projects: { required: true, type: Array },
      roles: { required: true, type: Array },
      defaultUser: { required: false, type: Object }
    },
    data() {
      return {
        user: {
            categories: [],
            projects: []
        },
        loading: false
      }
    },
    created() {
        if (this.defaultUser) this.user = this.defaultUser;
    },
    methods: {
      onSubmit() {

        if(this.user.role == undefined || (this.user.role).trim() == "" ){
          alert("Role field is required");
          return;
        }

        if(this.user.role == 'Person In Charge'){

          if(this.user.categories.length == 0){
            alert("Category field is required");
            return;
          }
        }

        this.loading = true;

        UserServices.save(this.user, (data) => {
          location.href = data.data;
          this.loading = false;
        }, (error)=>{
          
          // [Object.keys(obj)[0]]
          //.replace(/{|}|\[|\]|\"/g, "");
          //JSON.stringify(error.data.errors);

          let errMessage = error.data.errors;
          // console.log(errMessage);
          
          alert(errMessage[Object.keys(errMessage)[0]]);
          this.loading = false;
        });
      }
    }
  }
</script>